import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer, createTransform } from 'redux-persist';
import localforage from 'localforage';
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';
import { combineReducers } from "redux";
import auth from "./slices/authSlice";
import loanApplication from "./loanApplicationSlice";
import readiness from "./readinessSlice";
import { baseApi } from "../services/baseApi";

const allReducers = combineReducers({
    auth,
    loanApplication,
    readiness,
    [baseApi.reducerPath]: baseApi.reducer
});

export const rootReducer = (state, action) => {
    if (action.type === "auth/log-out" || action.type === "auth/clear-cache") {
        localforage.removeItem("persist:root");
        return allReducers(undefined, action);
    }

    return allReducers(state, action);
}

/** Do not persist readiness — always derive from current answers after rehydrate. */
const stripPersistedReadinessTransform = createTransform(
  (state) => {
    if (!state?.loanApplication) return state;
    const { readinessScore, ...loanApplication } = state.loanApplication;
    return { ...state, loanApplication };
  },
  (state) => {
    if (!state?.loanApplication) return state;
    return {
      ...state,
      loanApplication: { ...state.loanApplication, readinessScore: 0 },
    };
  },
);

const persistConfig = {
  key: 'root',
  storage: localforage,
  // `readiness` (the conversational /readiness experience) is deliberately
  // not persisted — every visit starts a fresh Owen conversation.
  blacklist: [baseApi.reducerPath, 'readiness'],
  transforms: [stripPersistedReadinessTransform],
};

const persistedReducer = persistReducer(persistConfig, rootReducer)

export const store = configureStore({
  reducer: persistedReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
      serializableCheck: {
          ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
  }).concat(baseApi.middleware)
});

export const persistor = persistStore(store);
